<div class="app-host-container">
  <div class="content-container iframe-wrapper">
    @if (isLoading) {
      <div class="loading-container">
        <kendo-loader type="infinite-spinner" size="large"></kendo-loader>
        <p>Loading {{ module?.name ?? 'module' }}...</p>
      </div>
    }
    @if (errorMessage && !isLoading) {
      <div class="error-container">
        <span class="k-icon k-i-warning"></span>
        <p>{{ errorMessage }}</p>
      </div>
    }
    @if (iframeUrl && !errorMessage) {
      <iframe [src]="iframeUrl" (load)="onIframeLoad($event)" class="app-host-iframe" frameborder="0"
              allow="clipboard-read; clipboard-write" [title]="module?.name ?? 'Module'"></iframe>
    }
  </div>
</div>
